import { render, staticRenderFns } from "./priceformat.vue?vue&type=template&id=276ceded&"
import script from "./priceformat.vue?vue&type=script&lang=js&"
export * from "./priceformat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('276ceded')) {
      api.createRecord('276ceded', component.options)
    } else {
      api.reload('276ceded', component.options)
    }
    module.hot.accept("./priceformat.vue?vue&type=template&id=276ceded&", function () {
      api.rerender('276ceded', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Y1OBydiAhTiU/JS/priceformat.vue"
export default component.exports